const events = {
  CHANGE: 'filters_change',
  SET_DATA: 'filters_set_data',
  SHOW: 'filters_show',
  HIDE: 'filters_hide',
  NUM_SELECTED_FILTERS_CHANGED: 'filters_num_selected_filters_changed',
};

export default events;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/filters/events.js